import React from 'react';

const ContactCTA: React.FC = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-r from-ariyva-indigo to-ariyva-electric">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-white mb-6">
          Ready to Transform Your Data Architecture?
        </h2>
        <p className="text-xl text-ariyva-light mb-8">
          Let's discuss how we can help you build scalable, intelligent data platforms that drive growth and innovation.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-white text-ariyva-indigo px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
            Schedule a Consultation
          </button>
          <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-ariyva-indigo transition-colors">
            View Our Services
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
